"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = void 0;

require("antd/lib/table/style");

var _table = _interopRequireDefault(require("antd/lib/table"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _mobxReact = require("mobx-react");

var _class;

var LapTable = (0, _mobxReact.observer)(_class =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(LapTable, _Component);

  function LapTable(props) {
    return _Component.call(this, props) || this;
  }

  var _proto = LapTable.prototype;

  _proto.render = function render() {
    var stopwatchStore = this.props.stopwatchStore;
    var lapStatStyle = {
      display: "inline-block",
      width: "120px"
    };
    return _react.default.createElement("div", null, _react.default.createElement("h3", null, "Laps"), _react.default.createElement("div", null, _react.default.createElement("label", {
      style: lapStatStyle
    }, "Fastest:"), _react.default.createElement("span", null, stopwatchStore.displayFastestLap)), _react.default.createElement("div", null, _react.default.createElement("label", {
      style: lapStatStyle
    }, "Slowest:"), _react.default.createElement("span", null, stopwatchStore.displaySlowestLap)), _react.default.createElement("div", null, _react.default.createElement("label", {
      style: lapStatStyle
    }, "Average:"), _react.default.createElement("span", null, stopwatchStore.displayAverageLap)), _react.default.createElement("br", null), _react.default.createElement(_table.default, {
      dataSource: stopwatchStore.splitData,
      pagination: false,
      style: {
        fontFamily: "HelveticaNeue-Light"
      }
    }, _react.default.createElement(_table.default.Column, {
      key: "lapNumber",
      title: "Lap #",
      dataIndex: "lapNumber"
    }), _react.default.createElement(_table.default.Column, {
      key: "lapTime",
      title: "Lap Time",
      render: function render(sd) {
        return sd.split.displayLap;
      }
    }), _react.default.createElement(_table.default.Column, {
      key: "splitTime",
      title: "Split Time",
      render: function render(sd) {
        return sd.split.displaySplit;
      }
    })));
  };

  return LapTable;
}(_react.Component)) || _class;

exports.default = LapTable;